module.exports = __webpack_public_path__ + "static/media/YF65_0.c87f3066.jpg";